import './assets/global.scss'

// Vue and outer application component
import Vue from 'vue'
import App from './App.vue'

// Reactive store and router
import { store } from './store.js'
import { router } from './router.js'

import VueGtm from 'vue-gtm'

// Some data specific to this application - exhibit groupings and Garden geo data
import exhibitGroups from './exhibit_groups.js'
import GardenZone from './garden_boundary.js'

// krpano for 360-degree videos
// import Krpano from 'vue-krpano'

// Common components reused throughout the application
import BigTop from './components/BigTop.vue'
import BottomNav from './components/BottomNav.vue'
import HelpButton from './components/HelpButton.vue'
import BackButton from './components/BackButton.vue'
import Logo from './components/Logo.vue'
import FooterLogos from './components/FooterLogos.vue'

// Exhibit data in lieu of loading remote JSON
// import TempData from './test-exhibit.json'

// Miscellaneous helper functions dealing with location
import getLevel from './location_utils.js'

import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'
import forOwn from 'lodash/forOwn'
import values from 'lodash/values'
import slugify from 'slugify'
import isNight from './isnight.js'

import { default as VueResource, Http } from 'vue-resource'

// Register common components
Vue.component('big-top', BigTop)
Vue.component('bottom-nav', BottomNav)
Vue.component('help-button', HelpButton)
Vue.component('back-button', BackButton)
Vue.component('logo', Logo)
Vue.component('FooterLogos', FooterLogos)
Vue.use(VueGtm, {
  id: 'GTM-KJH563M'
})
Vue.use(VueResource)

// Process and store static exhibit data - store.state.exhibits
forOwn(window.loclyExhibits.EXHIBITS, function (v, k) { v.friendly = slugify(v.name, {lower: true}) })
store.commit('setexhibits', window.loclyExhibits.EXHIBITS)
store.commit('setexhibitgroups', exhibitGroups)

// Calculate exhibit friendly URL components and map to IDs
let friendlies = mapValues(mapKeys(window.loclyExhibits.EXHIBITS, (v, k) => v.friendly), (v) => v.id)
store.commit('exhibitnames', friendlies)

// TEMP HACK: Store some example exhibit content until the CMS is hooked up
// store.commit('setexhibitdata', TempData)

let initList = values(window.loclyExhibits.EXHIBITS).map((item) => item.id)
//console.log('initlist', initList, window.loclyExhibits.EXHIBITS)
//no order is respected here
//store.commit('setnearest', initList)

// React to changes in the list of closest exhibits - store it in  store.state.nearest
/*window.loclyExhibits.on('exhibitListChange', function (e) {
  store.commit('setnearest', e.exhibits)
})*/

// React to device position changes - store distances to exhibits in store.state.distances
// Distances don't seem to change much unless the closest exhibit order changes in simulated mode.
// This should be followed up.
window.loclyLocation.on('unifiedPositionChange', function (e) {
  let distances = {}
  store.state.nearest.forEach(function (exhibit) {
    distances[exhibit] = window.loclyExhibits.getExhibitDistance(exhibit)
  })
  e.coords.level = getLevel(e.coords.altitude)
  store.commit('setuserposition', e.coords)
  store.commit('inzone', window.loclyLocation.isUnifiedInsidePolygon(GardenZone))
  window.isInZone = store.state.inzone
  store.commit('setdistances', distances)
})
store.commit('isnight', isNight())
setInterval(function () {
  store.commit('isnight', isNight())
}, 30000)

Http.get('https://pg.nybg.org/cms/wp-json/exhibits/v0/exhibits').then(function (response) {
  //reset the order here

  return new Promise((resolve,reject)=>{

    var data = response.json().then( data=>{
      var tempData = [];
      var exhibitData = [];
      var nearest = [];
      for (var key in data)
      {
        var part = data[key]
        var order = parseInt(part.order)
        nearest[order] = key
        tempData[order] = part
      }
      store.commit('setnearest',nearest)
      for(var i in tempData){
        exhibitData[tempData[i].exhibit_id] = tempData[i]
      }

      //because something keeps disrespecting our order here,
      //we have to fix it again
      store.commit('setexhibitdata', exhibitData)
      //console.log('nearest', nearest, 'exhibitData', exhibitData)
      resolve( nearest )
    }).catch(error=>{
    })

  }).catch(error=>{
  })

 //return response.json()

}).then(function (data) {
  //console.log('data', data)
  //store.commit('setexhibitdata', data)
  // Initialize the outer Vue app
  window.vapp = new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
  })
})
